import React from "react";
import { ListItem, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import { Submenu } from "../../typings/Submenu";

interface SingleLevelProps {
  item: Submenu;
  handleSubitemClick: (item: Submenu) => void;
  selectedItem?: string | null;
  onSelectItem?: (id: string) => void;
}

export const SingleLevel: React.FC<SingleLevelProps> = ({
  item,
  handleSubitemClick,
  selectedItem,
  onSelectItem
}) => {
  const handleSubitemClickHandler = (item: Submenu) => () => {
  handleSubitemClick(item);
    if (onSelectItem) {
      onSelectItem(item.url);
    }
  }
  
  return (
    <ListItem disablePadding>
      <ListItemButton
        onClick={handleSubitemClickHandler(item)}
        sx={{
          textIndent: item.identation,
          '&.Mui-selected': (theme) => ({
            backgroundColor: `${theme.palette.primary.dark} !important`,
            color: 'white'
          })
        }}
        selected={selectedItem === item.url}
      >
        <ListItemIcon />
        <ListItemText primary={item.name} />
      </ListItemButton>
    </ListItem>
  );
};
